export interface SuggestTitleStateI {
  template?: string;
  makeName?: string;
  modelName?: string;
  makeYear?: string;
  fuel?: string;
  cubicCapacity?: string;
  area?: number;
  categoryName?: string;
  cityName?: string;
  numberOfRooms?: string;
  settlementName?: string;
}

export default (value: SuggestTitleStateI) => {
  let template = value.template;
  const keys = Object.keys(value);

  keys.forEach(key => {
    if (template.includes(key)) {
      template = template.replace(`{${key}}`, value[key]);
    }
  });

  return template;
};



// WEBPACK FOOTER //
// ./src/utils/suggestTitleHelper.ts